import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ContractTypeId } from '@block-explorer/entities';

export const contractTypes = {
  [ContractTypeId.System]: 'System Contract',
  [ContractTypeId.Cep18]: 'CEP-18 Token',
  [ContractTypeId.CustomCep18]: 'CEP-18 Token',
  [ContractTypeId.CEP47Nft]: 'CEP-47 NFT',
  [ContractTypeId.CustomCEP47Nft]: 'CEP-47 NFT',
  [ContractTypeId.DeFi]: 'DeFi',
  [ContractTypeId.CEP78Nft]: 'CEP-78 NFT',
  [ContractTypeId.CustomCEP78Nft]: 'CEP-78 NFT',
  [ContractTypeId.NFTMarketplace]: 'NFT Marketplace',
  [ContractTypeId.CEP95Nft]: 'CEP-95 NFT',
};

export const shortenedContractTypes = {
  [ContractTypeId.System]: 'System',
  [ContractTypeId.Cep18]: 'Token',
  [ContractTypeId.CustomCep18]: 'Token',
  [ContractTypeId.CEP47Nft]: 'NFT',
  [ContractTypeId.CustomCEP47Nft]: 'NFT',
  [ContractTypeId.DeFi]: 'DeFi',
  [ContractTypeId.CEP78Nft]: 'NFT',
  [ContractTypeId.CustomCEP78Nft]: 'NFT',
  [ContractTypeId.NFTMarketplace]: 'NFT',
  [ContractTypeId.CEP95Nft]: 'NFT',
};

export const ContractTypeName = ({
  contractTypeId,
  short = false,
}: {
  contractTypeId: number | null;
  short?: boolean;
}) => {
  const { t } = useTranslation();

  const type = short ? shortenedContractTypes : contractTypes;

  return (
    <>{contractTypeId ? <Trans t={t}>{type[contractTypeId]}</Trans> : null}</>
  );
};
